import { Editor, truthy } from '@tencent/exeditor3-core';
import { BasicTheme } from '@tencent/exeditor3-theme-basic';
import { ItalicPlugin } from '@tencent/exeditor3-plugin-italic';
import { BoldPlugin } from '@tencent/exeditor3-plugin-bold';
import { UnderlinePlugin } from '@tencent/exeditor3-plugin-underline';
import { StrikethroughPlugin } from '@tencent/exeditor3-plugin-strikethrough';
import { ColorPlugin } from '@tencent/exeditor3-plugin-color';
import { FontSizePlugin } from '@tencent/exeditor3-plugin-font-size';
import { FontFamilyPlugin } from '@tencent/exeditor3-plugin-font-family';
import { BackgroundColorPlugin } from '@tencent/exeditor3-plugin-background-color';
import { HeadingPlugin } from '@tencent/exeditor3-plugin-heading';
import { QuotePlugin } from '@tencent/exeditor3-plugin-quote';
import { ListItemPlugin } from '@tencent/exeditor3-plugin-list-item';
import { BulletListPlugin } from '@tencent/exeditor3-plugin-bullet-list';
import { OrderListPlugin } from '@tencent/exeditor3-plugin-order-list';
import { TextAlignPlugin } from '@tencent/exeditor3-plugin-text-align';
import { TextIndentPlugin } from '@tencent/exeditor3-plugin-text-indent';
import { MarginBlockPlugin } from '@tencent/exeditor3-plugin-margin-block';
import { MarginSidePlugin } from '@tencent/exeditor3-plugin-margin-side';
import { LineSpacePlugin } from '@tencent/exeditor3-plugin-line-space';
import { WordSpacePlugin } from '@tencent/exeditor3-plugin-word-space';
import { HrPlugin } from '@tencent/exeditor3-plugin-hr';
import { CodeBlockPlugin } from '@tencent/exeditor3-plugin-code-block';
import { VideoPlugin } from '@tencent/exeditor3-plugin-video';
import { AudioPlugin } from '@tencent/exeditor3-plugin-audio';
import { PicturePlugin } from '@tencent/exeditor3-plugin-picture';
import { PictureTransformPlugin } from '@tencent/exeditor3-plugin-picture-transform';
import { ClearFormatPlugin } from '@tencent/exeditor3-plugin-clear-format';
import { PaintFormatPlugin } from '@tencent/exeditor3-plugin-paint-format';
import { ParagraphCheckPlugin } from '@tencent/exeditor3-plugin-paragraph-check';
import { PlaceholderPlugin } from '@tencent/exeditor3-plugin-placeholder';
import { TablesPlugin } from '@tencent/exeditor3-plugin-tables';
import { LinkPlugin } from '@tencent/exeditor3-plugin-link';
import { ToolbarCommonItemsPlugin } from '@tencent/exeditor3-plugin-toolbar-common-items';
import { SubScriptPlugin } from '@tencent/exeditor3-plugin-sub-script';
import { SuperScriptPlugin } from '@tencent/exeditor3-plugin-super-script';
import { FullscreenPlugin } from '@tencent/exeditor3-plugin-fullscreen';
import { EmojiPlugin } from '@tencent/exeditor3-plugin-emoji';
import { defaultConfig, mergeToolbarConfig } from './config.js';
/**
 * 快速创建一个包含大部分官方插件的编辑器实例
 */
export function createEditor(conf) {
    const config = {
        ...defaultConfig,
        ...conf,
    };
    const allTooltipItems = mergeToolbarConfig(config.toolbar)
        .trim()
        .split(/(\s|\(|\))+/);
    const createFilePluginConfig = (type) => ({
        inline: Boolean(config.inlineMedia),
        hasTitle: !config.noMediaTitle,
        upload: config.upload,
        acceptFile: (file) => config.acceptFile(type, file),
        uploadBySrc: config.uploadBySrc,
        isNeedToUploadBySrc: config.isNeedToUploadBySrc,
    });
    const presetPlugins = [
        new PlaceholderPlugin({ content: config.placeholder }),
        new ItalicPlugin(),
        new BoldPlugin(),
        new UnderlinePlugin(),
        new StrikethroughPlugin(),
        new ColorPlugin(),
        new FontSizePlugin(),
        new FontFamilyPlugin(),
        new BackgroundColorPlugin(),
        new ClearFormatPlugin(),
        new PaintFormatPlugin(),
        new HeadingPlugin(),
        new QuotePlugin(),
        new ListItemPlugin(),
        new BulletListPlugin(),
        new OrderListPlugin(),
        new CodeBlockPlugin(),
        new HrPlugin(),
        new PicturePlugin(createFilePluginConfig('picture')),
        new PictureTransformPlugin(createFilePluginConfig('picture')),
        new VideoPlugin(createFilePluginConfig('video')),
        new AudioPlugin(createFilePluginConfig('audio')),
        new TextAlignPlugin({ target: config.textblockAttrsTarget }),
        new TextIndentPlugin({ target: config.textblockAttrsTarget }),
        new MarginBlockPlugin({ target: config.textblockAttrsTarget }),
        new MarginSidePlugin({ target: config.textblockAttrsTarget }),
        new LineSpacePlugin({ target: config.textblockAttrsTarget }),
        new WordSpacePlugin(),
        new ParagraphCheckPlugin(),
        new ToolbarCommonItemsPlugin(),
        new TablesPlugin(),
        new LinkPlugin({ onCopy: config.onCopy }),
        new SubScriptPlugin(),
        new SuperScriptPlugin(),
        new FullscreenPlugin(),
        new EmojiPlugin(),
    ];
    const userPlugins = config.plugins.filter(truthy);
    return Editor.create({
        ...config,
        plugins: [
            ...userPlugins,
            ...presetPlugins.filter((p) => {
                if (userPlugins.some((up) => up.name === p.name)) {
                    return false;
                }
                if (!p.renderToolbarItem) {
                    return true;
                }
                const pluginMenuItems = typeof p.renderToolbarItem === 'object'
                    ? Object.keys(p.renderToolbarItem)
                    : [p.name];
                return pluginMenuItems.some((name) => allTooltipItems.includes(name));
            }),
        ],
    });
}
export { defaultConfig, BasicTheme, ItalicPlugin, BoldPlugin, UnderlinePlugin, StrikethroughPlugin, ColorPlugin, FontSizePlugin, FontFamilyPlugin, BackgroundColorPlugin, HeadingPlugin, QuotePlugin, ListItemPlugin, BulletListPlugin, OrderListPlugin, TextAlignPlugin, TextIndentPlugin, MarginBlockPlugin, MarginSidePlugin, LineSpacePlugin, WordSpacePlugin, HrPlugin, CodeBlockPlugin, VideoPlugin, AudioPlugin, PicturePlugin, ClearFormatPlugin, PaintFormatPlugin, ParagraphCheckPlugin, PlaceholderPlugin, TablesPlugin, LinkPlugin, ToolbarCommonItemsPlugin, SubScriptPlugin, SuperScriptPlugin, FullscreenPlugin, };
//# sourceMappingURL=index.js.map